<template>
  <div class="nav-item dropdown">
    <div style="cursor: pointer; d-flex" :ref="`dropdownMenu${id}`" data-bs-toggle="dropdown"
      @click="dropDownFlags.toggle()" aria-expanded="false">
      <font-awesome-icon :icon="['far', 'user-circle']" size="xl" color="white" />
    </div>
    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
      <li>
        <h6 :class="'dropdown-header ' + (isDark ? 'text-body-secondary' : '')">{{ $t("user.my_account") }}</h6>
      </li>
      <div class="d-flex flex-column align-items-start gap-2 px-3 pb-2">
        <small>
          <b>{{ $t("user.name") }}</b>
          <br />
          {{ user.data.displayName }}
        </small>

        <small>
          <b>{{ $t("user.email") }}</b>
          <br />
          {{ user.claims.email }}
        </small>

        <small>
          <b>{{ $t("user.state") }}</b>
          <br />
          <StateLabel :state="user.claims.state" />
        </small>
        <small>
          <b>{{ $t("home.microsoft_account_linked_title") }}</b>
          <div class="d-flex align-items-center gap-2">
            <img src="../../assets/microsoft-logo.svg" alt="Microsoft" />
            <span v-if="microsoftLinked" class="badge text-bg-success">{{ $t("home.microsoft_account_linked") }}</span>
            <span v-else class="badge text-bg-warning"> {{ $t("home.microsoft_account_not_linked") }}</span>
          </div>
        </small>
      </div>
      <li>
        <hr class="dropdown-divider" />
      </li>
      <li>
        <span class="dropdown-item cpt" @click="$emit('edit', id)">
          <font-awesome-icon :icon="['far', 'pen-to-square']" fixed-width class="me-1" />
          {{ $t("user.my_data") }}
        </span>
      </li>
      <li>
        <span class="dropdown-item cpt" @click="$emit('onLogout', id)">
          <font-awesome-icon :icon="['far', 'sign-out']" fixed-width class="me-1" />
          {{ $t("user.sign_out") }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { Dropdown } from "@comlinedev/bootstrap5";
import { mapGetters } from "vuex";
import StateLabel from "./StateLabel.vue";
import { useDark } from "@vueuse/core";

export default {
  name: "dropdownUserAccount",
  components: {
    StateLabel,
  },
  props: {
    id: String,
  },
  computed: {
    ...mapGetters({
      user: "user",
      microsoftLinked: "microsoftLinked",
    }),
  },
  data() {
    return {
      dropDown: null,
    };
  },
  mounted() {
    this.dropDownFlags = new Dropdown(this.$refs[`dropdownMenu${this.id}`]);
  },
  setup() {
    const isDark = useDark();
    return { isDark };
  },
};
</script>
<style scoped>
.badge-green {
  background-color: #28a745;
  color: white;
  padding: 0.2em 0.4em;
  border-radius: 45%;
}

.badge-red {
  background-color: #dc3545;
  color: white;
  padding: 0.2em 0.4em;
  border-radius: 50%;
}
</style>
